import React, { useState } from 'react';

import { useLots } from '../api/getLots';
import { RatesEditView } from './RatesEditView';
import { SelectLotModal } from './SelectLotModal';
import { SetupOverlay } from './SetupOverlay';

export const RatesOverlay = ({ resource, id, procurementName, onClose }) => {
  const [lotId, setLotId] = useState(null);
  const [isPickerOpen, setIsPickerOpen] = useState(true);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const { data: lots, refetch, isFetchedAfterMount } = useLots(resource, id);
  const lot = lots.find(({ lot_id }) => lot_id === lotId);

  const picker = (
    <SelectLotModal
      lots={lots}
      isLoaded={isFetchedAfterMount}
      open={isPickerOpen}
      handleClose={() => (lot ? setIsPickerOpen(false) : onClose())}
      onSelect={(selectedLot) => {
        setLotId(selectedLot.lot_id);
        setIsPickerOpen(false);
      }}
    />
  );

  if (!lot) return picker;

  return (
    <SetupOverlay
      procurementName={procurementName}
      crumbs={[{ label: 'Rates', onClick: () => setIsPickerOpen(true) }, { label: lot.name }]}
      isModalOpen={isPickerOpen || isConfirmOpen}
      onClose={onClose}
    >
      <RatesEditView
        key={lot.lot_id}
        resource={resource}
        id={id}
        lot={lot}
        onLotChanged={refetch}
        onModalChange={setIsConfirmOpen}
      />
      {picker}
    </SetupOverlay>
  );
};
